import GraphQLClient from 'ts/GraphQLClient'
import { RepoParams } from 'ts/types'
import {
  ActualsNewApiResponse,
  CreditsApiResponse,
  GetActualsNewResponse,
  GetCreditsParams,
  GetCreditsResponse
} from 'ts/types/actuals'
import { GET_ACTUALS, GET_CREDITS } from './graphql'

interface ActualsRepoParams {
  year: number
}

export default class ActualsRepo {
  private client: GraphQLClient

  constructor({ GRAPHQL_URL, ID_TOKEN }: RepoParams) {
    this.client = new GraphQLClient({ url: GRAPHQL_URL, idToken: ID_TOKEN })
  }

  async getActuals(params: ActualsRepoParams): Promise<GetActualsNewResponse> {
    const { year } = params

    const response = await this.client.request<ActualsNewApiResponse>({
      query: GET_ACTUALS,
      variables: {
        year
      }
    })

    return response.getUsageDetailsForUserNew
  }

  async getCredits(params: GetCreditsParams): Promise<GetCreditsResponse> {
    const { year, month } = params

    const response = await this.client.request<CreditsApiResponse>({
      query: GET_CREDITS,
      variables: {
        year,
        month
      }
    })

    return response.getCredits
  }
}
